var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c(
        "dl",
        [
          _c("dt", [_vm._v("Average Call Attempts")]),
          _c("dd", [_vm._v(_vm._s(_vm.report.call_attempts.median))]),
          _vm._v(" "),
          _c("dt", [_vm._v("Average Time to Answer")]),
          _c("dd", [_vm._v(_vm._s(_vm.report.time_to_answer.median))]),
          _vm._v(" "),
          _vm._l(_vm.report.regions, function(region) {
            return [
              _c("dt", { key: region.key + Math.random(region.value) }, [
                _vm._v("Calls for " + _vm._s(region.key) + " region")
              ]),
              _c("dd", { key: region.key }, [_vm._v(_vm._s(region.value))])
            ]
          })
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "progress" }, [
        _c(
          "div",
          {
            staticClass: "progress-bar bg-success",
            style: { width: _vm.report.percentage_calls_answered + "%" },
            attrs: {
              role: "progressbar",
              "aria-valuenow": "25",
              "aria-valuemin": "0",
              "aria-valuemax": "100"
            }
          },
          [
            _vm._v(
              "\n        " +
                _vm._s(_vm.report.percentage_calls_answered) +
                "% of calls answered\n      "
            )
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-heading" }, [
      _c("h5", { staticClass: "card-title" }, [_vm._v("Metrics")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dd0472a6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd0472a6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MetricCallLogs.vue
// module id = null
// module chunks = 